<template>
<svg viewBox="0 0 20 20" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Close`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.20711 1.79289C2.81658 1.40237 2.18342 1.40237 1.79289 1.79289C1.40237 2.18342 1.40237 2.81658 1.79289 3.20711L8.58579 10L1.79289 16.7929C1.40237 17.1834 1.40237 17.8166 1.79289 18.2071C2.18342 18.5976 2.81658 18.5976 3.20711 18.2071L10 11.4142L16.7929 18.2071C17.1834 18.5976 17.8166 18.5976 18.2071 18.2071C18.5976 17.8166 18.5976 17.1834 18.2071 16.7929L11.4142 10L18.2071 3.20711C18.5976 2.81658 18.5976 2.18342 18.2071 1.79289C17.8166 1.40237 17.1834 1.40237 16.7929 1.79289L10 8.58579L3.20711 1.79289Z"/></svg>
</template>
<script>

export default {
  name: 'IconClose',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
